import "core-js/modules/es.array.push.js";
var threadListParams = {
  perPage: 10,
  page: 1,
  'filter[essence]': 0,
  'filter[attention]': 0,
  'filter[sort]': 3,
  sequence: 0,
  'filter[categoryids][0]': 2
};
import { threadList } from '@/api/mg';
export default {
  watch: {
    inputValue: function inputValue() {
      threadListParams['filter[search]'] = this.inputValue;
      this.getThreadList(threadListParams);
    }
  },
  props: ['inputValue'],
  data: function data() {
    return {
      clubList: []
    };
  },
  created: function created() {
    threadListParams.page = 1;
    threadListParams['filter[title]'] = this.inputValue;
    this.getThreadList(threadListParams);
  },
  methods: {
    getThreadList: function getThreadList(params) {
      var _this = this;
      threadList(params).then(function (res) {
        if (res.Code === 0) {
          _this.clubList = res.Data.pageData;
          if (_this.clubList.length === 0) {
            _this.$toast('No Data');
          }
        } else {
          _this.$toast(res.Message);
        }
      });
    },
    toDetail: function toDetail(threadId) {
      this.$router.push({
        path: '/social/detail',
        query: {
          from: 'activity',
          threadId: threadId
        }
      });
    }
  }
};